import { PropsWithChildren } from "react";

export function Main({ children }: PropsWithChildren<NonNullable<unknown>>) {
  return <main className="flex-1 flex flex-col min-w-0 gap-16">{children}</main>;
}
